export default "__VITE_ASSET__4d7203ed__"